import axios from 'axios';

const retrieveSelectorData = async (url) => {
    try {
        return await axios.get(url, {timeout: 1000})
    } catch(retrError) {
        console.error(`FAILURE requesting type data from: ${url}.`, retrError)

        throw new Error('DataRetrievalFailure')
    }
}

export {
    retrieveSelectorData
}
